import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import CreateAccountContainer from './create-account/CreateAccountContainer';
import LoginContainer from './login/LoginContainer';
import SendConfirmationContainer from './send-confirmation/SendConfirmationContainer';
import VerifyEmailContainer from './verify-email/VerifyEmailContainer';
import ForgotPasswordContainer from './forgot-password/ForgotPasswordContainer';
import ResetQuestionsContainer from './reset-questions/ResetQuestionsContainer';
const MySwitch = Switch as any;
const MyRoute = Route as any;
const MyRedirect = Redirect as any;

function AuthRouter() {
  const { url } = useRouteMatch();

  return (
    <MySwitch>
      <MyRoute path={`${url}/login`} component={LoginContainer} />
      <MyRoute
        path={`${url}/create-account`}
        component={CreateAccountContainer}
      />
      <MyRoute
        path={`${url}/send-confirmation`}
        component={SendConfirmationContainer}
      />
      <MyRoute
        path={`${url}/forgot-password`}
        component={ForgotPasswordContainer}
      />
      <MyRoute path={`${url}/verify-email`} component={VerifyEmailContainer} />
      <MyRoute
        path={`${url}/reset-questions`}
        component={ResetQuestionsContainer}
      />
      <MyRedirect to={`${url}/login`} />
    </MySwitch>
  );
}

export default AuthRouter;
